import Table from './Table';

export default Table;



// WEBPACK FOOTER //
// ./src/components/Building/Chess/Table/index.js